import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import { isProduction } from '@zapier/common-utils';
import { readCookie } from '@zapier/cookies';
import { emit } from '@zapier/events-toolkit-browser';

import trackingFunctions, { trackEvent } from 'app/track/trackingFunctions';

type PopupSurveyEvent = 'shown' | 'completed' | 'dismissed';

const Data = {
  trackPageView(path: string, url: string, userId: string) {
    // We emit both /v3/events and /v4/event/ in the interim to ensure smooth
    // transition. When we're confident that events are correctly  updated, we can
    // emit /v4/events only.

    const identityId = readCookie('zapidentity');

    // TODO: Remove this /v3 pageview event.
    trackEvent('navigate_develop', {
      system_name: 'developer_platform',
      redirected_flag: false,
      identity_id: identityId,
      event_id: uuidv4(),
      page_path: path,
      path,
      release_id: process.env.COMMIT_HASH,
      timestamp_ms: Date.now(),
      user_agent: navigator.userAgent,
      user_id: userId,
      url_address: url,
      referer: document.referrer,
      learn_more_flag: false,
    });

    const eventType = 'web_analytics.tracking.page_view.PageViewEvent';
    const eventData = {
      identity_id: identityId,
      page_path: path,
      system_name: 'Platform Visual Builder',
      url_address: url,
      visitor_id: userId,
    };
    if (isProduction()) {
      emit(eventData, eventType);
    } else {
      console.info(
        `🧭 Would have tracked /v4/event/ "${eventType}"`,
        eventData
      );
    }
  },
  recordUserPopupSurvey(
    response: string | null | undefined,
    event: PopupSurveyEvent
  ) {
    trackEvent(`popup-survey:${event}`, {
      ...(response ? { response } : {}),
      path: _.get(document, ['location', 'pathname']),
    });
  },
  ...trackingFunctions,
};

export default Data;
